import Model, { attr, belongsTo } from '@ember-data/model';
import { tracked } from '@glimmer/tracking';
import { Type } from '@warp-drive/core-types/symbols';
import type { RiBreakdown } from 'frontend-utils/utils/constants/constant-values';
import { copyableModel } from 'frontend-utils/utils/ember-data';
import type { RevenueInsightSegmentationData } from 'lumen/models';
import CalculatedValues from 'lumen/utils/datamodels/revenue-insight/calculated-values';

@copyableModel
export default class ReviRemainingElement extends Model {
  [Type] = 'revi-remaining-element' as const;

  @belongsTo('revenue-insight/segmentation-data', {
    async: false,
    inverse: null,
  })
  declare forecastReference: RevenueInsightSegmentationData;

  @belongsTo('revenue-insight/segmentation-data', {
    async: false,
    inverse: null,
  })
  declare referenceValue: RevenueInsightSegmentationData;

  @belongsTo('revenue-insight/segmentation-data', {
    async: false,
    inverse: null,
  })
  declare value: RevenueInsightSegmentationData;

  @attr declare parentId: string | null;
  @attr declare remainingValues: string[];
  @attr declare unfilteredId: string;

  @tracked children?: unknown[];
  @tracked displayValue?: string;
  @tracked isAggregatedRow?: boolean;
  @tracked isSelectable?: boolean;
  @tracked parent?: unknown;
  @tracked pickupCount?: unknown;
  @tracked segmentationId?: RiBreakdown;
  @tracked segmentationSortValue?: unknown;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get calculatedValues() {
    return new CalculatedValues(this);
  }
}
